<template>
    <navbar></navbar>
</template>

<script>

import Navbar from '~/widgets/Navbar.vue'

export default {
  name: 'LayoutHeader',
  components: {
    Navbar
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layouts/LayoutHeader.vue